export default __webpack_public_path__ + "static/media/i-invite-link.83068f38.svg";